<!--
 * @Author: zhengxiaoxiao
 * @Date: 2020-08-12 15:57:59
 * @Description: 
-->
<template>
	<div
		class="service-banner"
		:style="{background: `url(${bannerContent.src})`,backgroundSize: 'cover',backgroundPosition: 'center'}"
	>
		<div class="title-warp">
			<ElRow class="title-content">
				<ElCol :xs="{span:20}" :sm="{span:20}" :md="{span:12}" :lg="{span:12}" :xl="{span:12}">
					<h1 class="title">{{bannerContent.title}}</h1>
					<p class="content" v-html="bannerContent.content"></p>
				</ElCol>
			</ElRow>
		</div>
	</div>
</template>

<script>
export default {
	name: 'banner',
	props: {
		bannerContent: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
}
</script>

<style lang='less' scoped>
@import '../../../style/constant';

.service-banner {
	height: 480px;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;

	.title-warp {
		/*padding: 60px 0;*/
		align-items: center;
		width: @page-width;

		.title-content {
			vertical-align: middle;

			h1 {
				color: #ffffff;
				line-height: 1.2em;
				margin-bottom: 30px;
				font-size: 44px;
				font-weight: 300
			}

			.content {
				color: #ffffff;
				line-height: 1.6em;
			}
		}
	}
	@media screen and (min-width: 320px) and (max-width: 480px) {
		.title-warp {
			padding: 0 20px;
		}
	}
}

@media screen and (min-width: 320px) and (max-width: 480px) {
	.service-banner {
		height: 40vh;
		background: #435ba1 !important;
	}
}
</style>